import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_delay",
  "use": "icon-workflow_delay-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_delay\">\n  <g>\n    <g transform=\"translate(3 5)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\">\n      <circle cx=\"12\" cy=\"12\" r=\"11\" />\n      <path stroke-linecap=\"round\" d=\"M12 12h6M12 12V6\" />\n    </g>\n    <rect x=\"8\" y=\"1\" width=\"14\" height=\"2\" rx=\"1\" />\n    <path d=\"M14 2h2v4h-2z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol